import React from 'react';
import Parser from 'html-react-parser';
import ContactModal from "../../ContactModal";
import {truncateText} from "../../../utils/wordsLimit";
import Breadcrumb from "../../common/Breadcrumb";

function HeroFormation({
                   titre,
                   description,
                   image,
                   nomImage,
                   btn,
                   url,
                   formationId,
                   lienFicheFormation,
                   formationArian,
                   formationTitleArian,
                   filArian = true,
                   optionalClass = ''
}) {

    const truncatedIntro = truncateText(description, 200, 100, 2);

    return (
        <section className={`banner-section-three -type-12 ${optionalClass}`}>
            <div className="bg-image">
                <div className="image-voile" style={{display: "none"}}></div>
            </div>
            <div className="auto-container">
                <div className="row">
                    <div className="content-column col-12">
                        <div className="inner-column">
                            <div className="d-flex flex-column gap-1 title-box wow fadeInUp">
                                {filArian ? (<Breadcrumb meta={formationTitleArian} formation={formationArian} />):""}
                                <h1 title={titre} className="petit">
                                    {typeof titre === 'string' ? Parser(titre) : ''}
                                </h1>
                            </div>

                            <div className="formation-image">
                                {image ? (
                                    <figure className="wow fadeIn" data-wow-delay="1500ms">
                                        <img src={image} alt={nomImage} />
                                    </figure>
                                ) : ''}

                                <div className="formation-cta-header">
                                    {formationId ? (
                                        <>
                                            {lienFicheFormation ? (
                                                <a href={lienFicheFormation}
                                                   target={'_blank'} rel={'noreferrer'}
                                                   className="theme-btn btn-style-one  d-flex flex-row justify-content-center align-items-center gap-1">
                                                    <i className={'cta-icons icon-Brochure-catalogue'}/>
                                                    Téléchargez la fiche formation
                                                </a>
                                            ): ''}
                                            <ContactModal formationId={formationId}
                                                          formationName={titre}
                                                          type={1}
                                                          textButton="Recevoir des informations"
                                                          defaultSkin={'btn-style-one'}
                                            />
                                        </>
                                    ): ''}
                                    {btn ? (
                                        <>
                                            <a href={url} className="theme-btn btn-style-one">{btn}</a>
                                        </>
                                    ): ''}
                                </div>

                                {/*<div className="header-text">*/}
                                {/*    {typeof description === 'string' ? Parser(truncatedIntro) : ''}*/}
                                {/*</div>*/}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );

}

export default HeroFormation;
